import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { AUTO_ID_FIELD } from '@cli-constants/schema.js'

export function ensureIdField(fields: SchemaField[]): SchemaField[] {
  const hasId = fields.some((f) => f.primaryKey || f.name === 'id')
  return hasId ? fields : [AUTO_ID_FIELD, ...fields]
}
